import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
export default {
  name: "Close",
  props: {
    info: {
      type: Object,
      default: function _default() {}
    },
    showClose: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      visible: false,
      loading: false
    };
  },
  methods: {
    confirmClose: function confirmClose() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this.loading = true;
              _context.n = 1;
              return _this.$api.closeReply({
                id: _this.$route.query.id
              });
            case 1:
              res = _context.v;
              if (res.data) {
                _this.visible = false;
                _this.$message.success("咨询已关闭");
                _this.$operationLog.push({
                  operationType: "consult",
                  code: "close",
                  detailBatchNo: _this.$route.query.id,
                  userId: _this.$route.query.userId,
                  houseCode: _this.info.serialNumber
                });
                _this.$router.back();
              } else {
                _this.$message.success("咨询关闭失败");
              }
              _this.loading = false;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    handleClose: function handleClose() {
      this.visible = true;
    }
  }
};